<template>
    <div class="radio__item" :class="'room_' + id">

        <!-- Default input, which is hidden -->

    <input type="radio" :id="'room_' + id" name="radios" value="" class="b radio__input" @change="setSelectedRoom(id)" :checked="isRoomSelected(id)">

        <!-- Content (this needs to be right after radio input for the styles to work properly-->

        <label :for="'room_' + id" class="radio__content">

        <div class="radio__main">

        <!-- Tiny image carousel full screen carousel on click -->

        <div class="tiny-carousel radio__carousel carousel-toggle" :class="{'no-image': checkImage}" @click="openRoomLightBox(0)" :style="{ backgroundImage: `url('${image[0]}')` }">
        </div>

        <!-- Title -->

        <div class="radio__head">

            <h2 class="radio__title">{{ title }} </h2>
            <!-- Meta information -->

            <ul class="inline-list inline-list--small radio__meta">
              <li class="inline-list__item">For {{ roomMax }} {{ strings.people }}</li>
            </ul>

        </div>

        <!-- Pricing -->

        <div class="radio__pricing">
            <h3 class="radio__price"> {{ currencySymbol }} {{ roomPriceVat  }} </h3>
            <h4 class="radio__audience">{{ strings.forselectedduration }}</h4>
        </div>

        </div>

    </label>
    <lightbox
         :images="images"
         ref="roomLightbox"
         :showLightBox="false"
         :show-caption="false"
     ></lightbox>
    </div>
</template>

<script>
import Lightbox from 'vue-image-lightbox';

export default {
    data() {
        return {
            isHidden : true,
            images: [],
        }
    },
    components: {
      Lightbox
    },
    props: [
        'id',
        'title',
        'roomMin',
        'roomMax',
        'roomPriceVat',
        'roomLayout',
        'image'
    ],
    methods: {
        openRoomLightBox(index) {
            let allImages;
            this.images = [];
            for (let i=0; i <  this.image.length; i++) {
              allImages = {
                thumb: this.image[i],
                src: this.image[i],
              }
              this.images.push(allImages);
            }

            if(this.image != '') {
                this.$refs.roomLightbox.showImage(index);
            }
        },
        isRoomSelected(roomID){
            if(this.$store.state.selectedRegusRoom == roomID){
                return true;
            }
        },
        setSelectedRoom(roomID){
            this.$store.state.regusRoomInfo.forEach(el => {
                if(el.id == roomID){
                    this.$store.dispatch('changeRoomRegus', el);
                }
            });
        }
    },
    computed: {
        currencySymbol(){
            return this.$store.state.currencySymbol;
        },
        notNumericMT() {
            let mt_length = this.$store.state.meeting_length;
            if(mt_length == 'overnight' || mt_length == 'twodays'){
                return true;
            } else {
                return false;
            }
        },
        selectedLang () {
            return this.$store.state.selectedLang;
        },
        strings () {
  	        return this.$store.state.strings
        },
        checkImage() {
            if(this.image == '') {
                return true;
            }
            else {
                return false
            }
        },
        meetingLength() {
            return this.$store.state.meeting_length;
        },
    }
}
</script>
